import { combineReducers } from 'redux';
import auth from './auth/authreducer';
import activedevoteeReducer from './activedevoteestatistics/activedevoteestatisticsreducer';

const reducers = combineReducers({
    auth,
    activedevoteeReducer
})

export default reducers;